import React, { useEffect, useRef, useState } from "react";
import {
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  ModalFooter,
} from "reactstrap";

// redux toolkit
import { shallowEqual, useSelector } from "react-redux";

// görsel zoom
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

// Slider (Carousel) için eklenenler
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./AnnouncementModal.css";

const AnnouncementModal = () => {
  const [modal, setModal] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [modalTitle, setModalTitle] = useState("Duyurular");
  const sliderRef = useRef(null);

  const { preloader, announcementIsDefault } = useSelector((state) => {
    return {
      preloader: state.Layout.preloader,
      announcementIsDefault: state.announcement.announcementIsDefault,
    };
  }, shallowEqual);

  useEffect(() => {
    const onBeforeUnload = () => {
      sessionStorage.setItem("pageReloaded", "true");
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, []);

  const getViewedAnnouncements = () => {
    const viewedIdsStr = sessionStorage.getItem("viewedAnnouncementIds");
    return viewedIdsStr ? JSON.parse(viewedIdsStr) : [];
  };

  const markAsViewed = (id) => {
    const viewedIds = getViewedAnnouncements();
    if (id && !viewedIds.includes(id)) {
      const newViewedIds = [...viewedIds, id];
      sessionStorage.setItem(
        "viewedAnnouncementIds",
        JSON.stringify(newViewedIds)
      );
    }
  };

  useEffect(() => {
    if (preloader === "enable" && announcementIsDefault.length > 0) {
      const timer = setTimeout(() => {
        const isReload = sessionStorage.getItem("pageReloaded") === "true";
        if (isReload) {
          sessionStorage.removeItem("viewedAnnouncementIds");
          sessionStorage.setItem("pageReloaded", "false");
        }
        const viewedIds = getViewedAnnouncements();

        const firstUnseenAnnouncement = announcementIsDefault.find(
          (ann) => !viewedIds.includes(ann.Id)
        );

        if (firstUnseenAnnouncement) {
          const nextIndex = announcementIsDefault.findIndex(
            (ann) => ann.Id === firstUnseenAnnouncement.Id
          );
          if (nextIndex > -1) {
            setModalTitle(
              announcementIsDefault[nextIndex]?.AnnouncementTitle || "Duyurular"
            );
            setCurrentSlide(nextIndex);
            markAsViewed(firstUnseenAnnouncement.Id);
            setModal(true);
          }
        }
      }, 460);

      return () => clearTimeout(timer);
    }
  }, [preloader, announcementIsDefault]);

  const totalSlides = announcementIsDefault.length;
  const isInfinite = totalSlides > 1;

  const sliderSettings = {
    dots: false,
    infinite: isInfinite,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    swipe: false,
    draggable: false,
    adaptiveHeight: true,
    initialSlide: currentSlide,
    beforeChange: (oldIndex, newIndex) => {
      setCurrentSlide(newIndex);
      const nextAnnouncement = announcementIsDefault[newIndex];
      if (nextAnnouncement) {
        setModalTitle(nextAnnouncement.AnnouncementTitle || "Duyurular");
        markAsViewed(nextAnnouncement.Id);
      }
    },
  };

  return (
    <Modal size="lg" isOpen={modal} toggle={() => setModal(false)} centered>
      <ModalHeader
        className="modal-title justify-content-center"
        id="myLargeModalLabel"
        toggle={() => setModal(false)}
      >
        {modalTitle}
      </ModalHeader>
      <ModalBody>
        <div className="announcement-slider-container">
          <Slider ref={sliderRef} {...sliderSettings}>
            {announcementIsDefault.map((announcement) => (
              <div key={announcement.Id} className="announcement-slide">
                <Row className="align-items-start">
                  <Col xs={12}>
                    <p style={{ whiteSpace: "pre-wrap" }}>
                      {announcement.AnnouncementContent}
                    </p>
                  </Col>
                  {announcement.AnnouncementImageUrl && (
                    <Col xs={12} className="text-center mt-2">
                      <Zoom>
                        <img
                          src={
                            "https://api.globalyolyardim.com" +
                            announcement.AnnouncementImageUrl
                          }
                          alt="Duyuru Resmi"
                          style={{
                            maxWidth: "100%",
                            height: "auto",
                            borderRadius: "8px",
                          }}
                        />
                      </Zoom>
                    </Col>
                  )}
                </Row>
              </div>
            ))}
          </Slider>
        </div>
      </ModalBody>
      {totalSlides > 1 && (
        <ModalFooter className="announcement-footer">
          <button
            className="announcement-nav-button"
            onClick={() => sliderRef.current?.slickPrev()}
            aria-label="Önceki Duyuru"
            disabled={!isInfinite && currentSlide === 0}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
          </button>

          <button
            className="announcement-nav-button"
            onClick={() => sliderRef.current?.slickNext()}
            aria-label="Sonraki Duyuru"
            disabled={!isInfinite && currentSlide === totalSlides - 1}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </button>
        </ModalFooter>
      )}
    </Modal>
  );
};

export default AnnouncementModal;
